//
//
//
//
//
//
//
//
//
//
//
//
//

import placeIcon from '~/assets/img/icons/place.svg?raw'
import openArrow from '~/assets/img/icons/longArrow.svg?raw'

export default {
    name: "ShopsListItem",
    props: {
        shop: {
            type: Object,
            default: () => { return {} }
        },
        activeId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            placeIcon: placeIcon,
            openArrow: openArrow,
            yourCoordinate: null,
        }
    },
    computed: {
        destination() {
            let lat1 = this.shop.coordinates.lat,
                lng1 = this.shop.coordinates.lng,
                lat2 = this.yourCoordinate.latitude,
                lng2 = this.yourCoordinate.longitude;

            let earthRadiusKm = 6371;
            let dLat = this.degreesToRadians(lat2-lat1);
            let dLon = this.degreesToRadians(lng2-lng1);
            lat1 = this.degreesToRadians(lat1);
            lat2 = this.degreesToRadians(lat2);

            let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

            return (earthRadiusKm * c).toFixed(2) + this.$t('static.storeFinder.destinationAfter');
        },
        isActive() {
            return this.activeId === this.shop.id
        }
    },
    methods: {
        chooseShop() {
            this.$emit('chooseShop', this.shop);
        },
        degreesToRadians(degrees) {
            return degrees * Math.PI / 180;
        }
    },
    mounted() {
        navigator.geolocation.getCurrentPosition(function(position) {
            this.yourCoordinate = position.coords;
        }.bind(this));
    }
}
